<template>
	<div>
		<topback title="Withdraw" path="/my"></topback>
    <div class="main">
      <div class="noassets" v-if="noassets_show">
          <md-result-page
            class="customized"
            img-url="/static/icon/noassets.png"
            text="Your account has no assets"
            subtext="Deposit or buy crypto to start">
          </md-result-page>
      </div>
      
      <md-field class="assetslist">
          <md-cell-item title="USDT" addon="100000.00 USDT">
              <div class="holder" slot="left">
              <iconimg name="usdt" class="assetslist-img"></iconimg>
              </div>
          </md-cell-item>
          <md-cell-item title="INR" addon="12222.00 INR">
              <div class="holder" slot="left">
              <iconimg name="recharge" class="assetslist-img"></iconimg>
              </div>
          </md-cell-item>
      </md-field>

      <md-field>
        <md-field-item solid title="Withdraw">
          <!-- <p slot="children">这是子内容区域</p> -->
        </md-field-item>
        <md-field-item title="Account" solid>
          <md-radio name="2" v-model="withdraw_account" label="USDT" inline />
          <md-radio name="1" v-model="withdraw_account" label="INR" inline />
          <p slot="children">Amount</p> 
        </md-field-item>
        <md-field-item>
          <md-input-item
            type="money"
            v-model="amount"
            brief="理财提示文案，字符超出10个自动变小理财提示文案，字符超出10个自动变小理财提示文案，字符超出10个自动变小理财提示文案，字符超出10个自动变小理财提示文案，字符超出10个自动变小"
            placeholder="最多30万元"
            is-amount
            is-highlight
          >
            <div class="input-operator" slot="right" @click="takeAll">Max</div>
          </md-input-item>
          <p slot="children">Payment Method</p> 
        </md-field-item>
        <md-field-item title="Select" :content="selectorValue" @click="show_payment_method_selector" arrow solid />
      </md-field>

      <md-selector
        v-model="isSelectorShow"
        :data="selectordata[0]"
        hide-title-bar
        large-radius
        is-check
        iconSize="lg"
        @choose="onSelectorChoose"
        class="withdraw-selector"
      >
        <div class="selector-header" slot="header">
          Select Payment Method
        </div>
        <template slot-scope="{ option, index, selected }">
          <!-- <div class="md-selector-custom-brief">{{ option.text }}使用slot-scope</div> -->
          <div class="selector-item-body" :class="{disabled: option.disabled, selected}">
            <div class="selector-item-left">
              <span class="holder" v-text="option.value"></span>
            </div>
            <div class="selector-item-content">
              <p class="selector-item-title" v-text="option.text"></p>
              <p class="selector-item-brief" v-text="`${option.describe}-${index}`"></p>
            </div>
          </div>
        </template>
        <div class="selector-footer" slot="footer">
          Footer Slot
        </div>
      </md-selector>

      <md-button type="primary" loading>Withdraw</md-button>    
    </div>
	</div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'


export default {
	name: 'withdraw',

	components: {
		[topback.name]: topback,
    [iconimg.name]: iconimg
	},

	data() {
		return {
			noassets_show: false,
      withdraw_account: "USDT",
      amount: 1200,
      selectorValue: "USDT: jGASA****SFFF",
      isSelectorShow: false,
      selectordata: [
        [
          {
            value: 'A',
            text: 'payment method 01',
            describe: 'address: ssssssssssss',
          },
          {
            value: 'B',
            text: 'payment method 02',
            describe: 'address: ssssssssssss',
          },
          {
            value: 'C',
            text: 'payment method 03',
            describe: 'address: ssssssssssss',
            disabled: true,
          },
          {
            value: 'D',
            text: 'payment method 04',
            describe: 'address: ssssssssssss',
          },
        ],
      ]
		}
	},

	methods: {
    go_usdt_recharge() {
      this.$router.push("/depositusdt")
    },
    takeAll() {
      this.value = '300000'
    },
    show_payment_method_selector() {
      this.isSelectorShow = true
    },
    onSelectorChoose({text}) {
      this.selectorValue = text
    },
	}
}

</script>
<style scoped>
.main {
  margin-top: 0.7rem;
}
.btngroup .holder {
  margin: 10px auto;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.btnitem .title {
  font-size: 0.1rem;
  margin: 5px;
}

.btngroup {
  margin: 0.2rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.btngroup .btnitem {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: calc(90% / 3);
  height: calc(90% / 3);
  border-radius: 20px;
  box-shadow: 0 8px 12px #ebedf0;
  overflow: auto;
}
.noassets {
  margin-top: 1.5rem;
}

.assetslist {
  margin-bottom: 0rem;
  padding-bottom: 0rem;
}

.assetslist .holder {
  line-height: 0px;
  font-size: 39px;
}
.assetslist-img {
  width: 0.42rem;
}

.assetslist  >>> .md-cell-item-right {
  color: black;
}

.noassets >>> .md-result-image {
  width: 1.6rem;
}
.noassets >>> .md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets >>> .md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}

.withdraw-selector .selector-header, .withdraw-selector .selector-footer {
     padding: 15px 40px;
     font-size: 16px;
     color: #ccc;
}
 .withdraw-selector .selector-item-body {
     display: flex;
     align-items: center;
}
 .withdraw-selector .selector-item-body.selected .selector-item-content {
     color: #2f86f6;
}
 .withdraw-selector .selector-item-body.disabled {
     opacity: 0.3;
}
 .withdraw-selector .selector-item-body .selector-item-left {
     flex-shrink: 0;
     margin-right: 32px;
}
 .withdraw-selector .selector-item-body .selector-item-left .holder {
     display: block;
     width: 88px;
     height: 88px;
     border-radius: 44px;
     background-color: #e6e6e6;
     font-size: 32px;
     font-weight: 500;
     color: #2f86f6;
     text-align: center;
     line-height: 88px;
}
 .withdraw-selector .selector-item-body .selector-item-content {
     flex: 1;
     color: #111a34;
     font-size: 32px;
     line-height: 1.2;
}
 .withdraw-selector .selector-item-body .selector-item-content .selector-item-title {
     line-height: 1.2;
}
 .withdraw-selector .selector-item-body .selector-item-content .selector-item-brief {
     color: #858b9c;
     font-size: 24px;
     line-height: 1.4;
     margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/my/withdraw.vue